import qs from 'qs'
import { withHeadersInstance } from './api-instance.js'
const baseUrl = process.env.VUE_APP_URL_API

export const GetStudentList = async function(locationId, parameters) {
    try {
        const queryUrl = '?' + qs.stringify(parameters)
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/location/${locationId}/students${queryUrl}`,
        })
    } catch (e) {
        console.error(e)
        return e.response.data
    }
}

export const GetStudent = async function(studentPublicId, locationId) {
    try {
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/location/${locationId}/student/${studentPublicId}`,
        })
    } catch (e) {
        console.error(e)
        return e.response.data
    }
}

export const GetStudentTimeline = async function(studentPublicId, locationId) {
    try {
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/location/${locationId}/student/${studentPublicId}/career/timeline`,
        })
    } catch (e) {
        console.error(e)
        return e.response.data
    }
}

export const PostStudent = async function(data) {
    try {
        if (data === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: data')
            )
        return await withHeadersInstance({
            method: 'post',
            url: `${baseUrl}/student`,
            data: data,
        })
    } catch (e) {
        console.error(e)
        return e.response
    }
}

export const UpdateStudent = async function(student) {
    try {
        const { publicId } = student
        if (publicId === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: publicId')
            )

        return await withHeadersInstance({
            method: 'put',
            url: `${baseUrl}/student/${publicId}`,
            data: student,
        })
    } catch (e) {
        console.error(e)
        return e.response
    }
}

export const ChangeStudentStatus = async function(parameters) {
    try {
        const { publicId } = parameters
        if (publicId === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: publicId')
            )
        return await withHeadersInstance({
            method: 'put',
            url: `${baseUrl}/student/${publicId}/change-status`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}

export const DeleteStudent = async function({
    studentPublicId,
    locationPublicId,
}) {
    try {
        if (studentPublicId === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: studentPublicId')
            )
        if (locationPublicId === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: locationPublicId')
            )
        return await withHeadersInstance({
            method: 'delete',
            url: `${baseUrl}/location/${locationPublicId}/student/${studentPublicId}`,
        })
    } catch (e) {
        console.error(e)
    }
}
